import { MeetingResourceCitation, MeetingSentenceCitation } from '../../../../../../backend/src/citations/minutes-citations-api.dto'

export const LLM_LIVE_DEFAULT_TIMEOUT_SECONDS = 60
export const LLM_LIVE_DEFAULT_WARNING_SECONDS = LLM_LIVE_DEFAULT_TIMEOUT_SECONDS * 0.25

export type LlmAction =
  'elaborate' | 'shorten' | 'bulletize' | 'prosify' | 'make_active_voice' | 'make_passive_voice' | 'make_past_tense' | 'anonymize' | 'name_names' | 'fact_check'

export type SentenceIdPair = {
  startSentenceId: string
  endSentenceId: string
}

export type FactCheckResolution = {
  statement: string
  answer: 'True' | 'False' | 'Unclear'
  reason: string
  newWording: string | null
  citations: (MeetingSentenceCitation | MeetingResourceCitation)[]
}

export type StreamingChunk = {
  result: string
  isFinal: boolean
}

export type AiActionConfig = {
  action: LlmAction
  i18nKey: string
  stream: boolean
  icon: string
}

export const AI_ACTION_CONFIGS: AiActionConfig[] = [
  {
    action: 'elaborate',
    i18nKey: 'EDITOR.ACTIONS.ELABORATE',
    stream: true,
    icon: 'subject',
  },
  {
    action: 'shorten',
    i18nKey: 'EDITOR.ACTIONS.SHORTEN',
    stream: true,
    icon: 'short_text',
  },
  {
    action: 'make_active_voice',
    i18nKey: 'EDITOR.ACTIONS.MAKE_ACTIVE_VOICE',
    stream: true,
    icon: 'lightbulb',
  },
  {
    action: 'make_passive_voice',
    i18nKey: 'EDITOR.ACTIONS.MAKE_PASSIVE_VOICE',
    stream: true,
    icon: 'lightbulb_outline',
  },
  {
    action: 'make_past_tense',
    i18nKey: 'EDITOR.ACTIONS.MAKE_PAST_TENSE',
    stream: true,
    icon: 'history',
  },
  {
    action: 'anonymize',
    i18nKey: 'EDITOR.ACTIONS.ANONYMIZE',
    stream: true,
    icon: 'group_off',
  },
  {
    action: 'name_names',
    i18nKey: 'EDITOR.ACTIONS.NAME_NAMES',
    stream: true,
    icon: 'group',
  },
  {
    action: 'fact_check',
    i18nKey: 'EDITOR.ACTIONS.FACT_CHECK_STATEMENT',
    stream: false,
    icon: 'fact_check',
  },
]
